var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, JsonpModule } from '@angular/http';
import { AppRoutingModule } from './app.routing';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { ReCaptchaModule } from 'angular2-recaptcha';
// common components
import { AppComponent } from './app.component';
import { NovedadesComponent } from './components/novedades/novedades.component';
import { SearchComponent } from './components/search/search.component';
import { PreferenciaComponent } from './components/preferencia/preferencia.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { MenuComponent } from './components/menu/menu.component';
import { Pager } from './common/pager/pager.component';
import { ActuacionPopupComponent } from './components/actuacion/actuacion-popup.component';
import { EscritoPopupComponent } from './components/escrito/escrito-popup.component';
import { SearchResultComponent } from './components/search/search-result.component';
import { ExpedienteViewComponent } from './components/expediente/expediente-view.component';
import { DespachoDiarioComponent } from './components/despacho-diario/despacho-diario.component';
import { UsuarioComponent } from './components/usuario/usuario.component';
import { UsuarioPopupComponent } from './components/usuario/usuario-popup.component';
import { UsuarioViewComponent } from './components/usuario/usuario-view.component';
import { FavoritosComponent } from './components/favoritos/favoritos.component';
import { CedulaComponent } from './components/cedula/cedula.component';
import { EscritoPresentarComponent } from './components/escrito/escrito-presentar.component';
import { CedulaFilterComponent } from './components/cedula/cedula-filter.component';
// import { ExpedienteDespachoViewComponent } from './components/expediente/expediente-despacho-view.component';
import { DespachoDiarioFilterComponent } from './components/despacho-diario/despacho-diario-filter.component';
import { ExpedienteFilterComponent } from './components/expediente/expediente-filter.component';
import { SearchXsComponent } from './components/search/search-xs.component';
import { ExpedienteListComponent } from './components/expediente/expediente-list.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { PerfilPopupComponent } from './components/perfil/perfil-popup.component';
import { TasasPopupComponent } from './components/tasa/tasa-popup.component';
import { ComprobantePopupComponent } from './components/tasa/comprobante-popup.component';
import { PopupRecaptcha } from './common/recaptcha/popup-recaptcha';
import { NuevaCausaComponent } from './components/ingresocausa/nueva-causa.component';
import { DatosDemandaComponent } from './components/ingresocausa/datos-demanda.component';
import { PartesCausaComponent, ChildTable } from './components/ingresocausa/partes-causa.component';
import { DemandaComponent } from './components/ingresocausa/demanda.component';
import { FichaComponent } from './components/ingresocausa/ficha.component';
import { FirmarComponent } from './components/ingresocausa/firmar.component';
import { RepreCausaPopupComponent } from './components/ingresocausa/repre-causa-popup.component';
import { WizardComponent } from './common/wizard/wizard.component';
import { WizardStepComponent } from './common/wizard/wizard-step.component';
import { IngresoMasivoComponent } from './components/ingresomasivo/ingreso-masivo.component';
import { TasasNoExpComponent } from './components/tasa/tasa-noexp.component';
import { Signer } from './common/firmador/firma-helper.component';
import { DualListComponent } from './common/dual-list.component';
import { StringDateFormatter } from './common/pipes';
import { AutocompleteComponent } from './common/autocomplete/autocomplete.component';
import { Message } from './common/dialog/mensaje.component';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { LoadingIndicator } from './common/loading/loading.indicator';
import { Collapse } from './common/collapse.component';
// user components
import { KeycloakService } from './services/keycloak.service';
import { ExpedienteService } from './services/expediente.service';
import { ActuacionService } from './services/actuacion.service';
import { CommonService } from './services/common.service';
import { SharedService } from './services/shared.service';
import { LogService } from './services/log.service';
import { DespachoService } from './services/despacho.service';
import { SearchService } from './services/search.service';
import { CedulaService } from './services/cedula.service';
import { UsuarioService } from './services/usuario.service';
import { PerfilService } from './services/perfil.service';
import { TasasService } from './services/tasas.service';
import { HttpClientWrapper } from './services/httpClient';
import { LoadingService } from './common/loading/loading.service';
//import { HttpClient, HttpHandler } from '@angular/common/http';
import { UsuarioNoAutorizadoComponent } from './components/usuario-no-autorizado/usuario-no-autorizado.component';
import { DatosIngresoComponent } from './components/ingresocausa/datos-ingreso.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { AgendaFilterComponent } from './components/agenda/agenda-filter.component';
import { AgendaoService } from './services/agenda.service';
import { ExpedienteDownloadComponent } from './components/expediente/expediente-download.component';
import { UuidViewComponent } from './components/uuid/uuid-view.component';
import { EnlaceNoAutorizadoComponent } from './components/enlace-no-autorizado/enlace-no-autorizado.component';
import { UuidService } from './services/uuid.service';
import { UuidActuacionPopupComponent } from './components/uuid-actuacion/uuid-actuacion-popup.component';
import { WebSocketService } from './services/websocket.service';
import { RepresentanteQrPopupComponent } from './components/parte/representante-qr-popup.component';
import { UuidParteDeshabilitadoComponent } from './components/uuid-parte/uuid-parte-deshabilitado.component';
import { UuidParteViewComponent } from './components/uuid-parte/uuid-parte-view.component';
import { UuidParteService } from './services/uuidparte.service';
export { AppComponent };
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = __decorate([
    NgModule({
        imports: [
            BrowserModule,
            HttpModule,
            JsonpModule,
            FormsModule,
            ReactiveFormsModule,
            AppRoutingModule,
            NgIdleKeepaliveModule.forRoot(),
            Ng2Bs3ModalModule,
            ReCaptchaModule,
        ],
        declarations: [
            AppComponent,
            DualListComponent,
            Message,
            Signer,
            MenuComponent,
            Pager,
            NovedadesComponent,
            PreferenciaComponent,
            SearchComponent,
            NotFoundComponent,
            StringDateFormatter,
            UsuarioComponent,
            // user components
            ActuacionPopupComponent,
            EscritoPopupComponent,
            ExpedienteViewComponent,
            ExpedienteDownloadComponent,
            SearchResultComponent,
            DespachoDiarioComponent,
            AgendaComponent,
            UsuarioViewComponent,
            FavoritosComponent,
            CedulaComponent,
            EscritoPresentarComponent,
            CedulaFilterComponent,
            //ExpedienteDespachoViewComponent,
            DespachoDiarioFilterComponent,
            AgendaFilterComponent,
            ExpedienteFilterComponent,
            SearchXsComponent,
            ExpedienteListComponent,
            UsuarioPopupComponent,
            PerfilPopupComponent,
            PerfilComponent,
            TasasPopupComponent,
            AutocompleteComponent,
            ComprobantePopupComponent,
            PopupRecaptcha,
            LoadingIndicator,
            Collapse,
            NuevaCausaComponent,
            DatosDemandaComponent,
            DatosIngresoComponent,
            PartesCausaComponent,
            ChildTable,
            DemandaComponent,
            FichaComponent,
            FirmarComponent,
            RepreCausaPopupComponent,
            WizardComponent,
            WizardStepComponent,
            IngresoMasivoComponent,
            UsuarioNoAutorizadoComponent,
            TasasNoExpComponent,
            UuidViewComponent,
            EnlaceNoAutorizadoComponent,
            UuidActuacionPopupComponent,
            RepresentanteQrPopupComponent,
            UuidParteDeshabilitadoComponent,
            UuidParteViewComponent,
        ],
        providers: [
            KeycloakService,
            ActuacionService,
            ExpedienteService,
            CommonService,
            SharedService,
            LogService,
            DespachoService,
            SearchService,
            CedulaService,
            UsuarioService,
            PerfilService,
            TasasService,
            LoadingService,
            AgendaoService,
            HttpClientWrapper,
            UuidService,
            WebSocketService,
            UuidParteService,
        ],
        bootstrap: [AppComponent]
    })
], AppModule);
export { AppModule };
//# sourceMappingURL=app.module.js.map